export default {"src":"/_next/static/media/instagram.7d14ded2.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};